module.exports = __webpack_public_path__ + "static/img/logo_1.7bcde36e.svg";